import React from "react";
import Lottie from "lottie-react";
import AnimationData from "../../assets/loadingLottie.json";

const LoadingLottie = () => {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="md:w-[20rem] w-[17rem]">
        <Lottie animationData={AnimationData} />
      </div>
      <div
        className="text-[#130C40] lg:text-3xl md:text-xl text-lg font-bold mt- w-[20rem] text-center"
        style={{ fontFamily: "DM Sans" }}
      ></div>
    </div>
  );
};

export default LoadingLottie;
